// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1KRal","choiceBoxes":"toolbarselects_choiceBoxes__3MZO3","simpleField":"toolbarselects_simpleField___xAx-"};